import { type ReactNode, useState } from 'react';
import { History } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { InvestmentHistoryModal } from './investment-history-modal';

export function InvestmentHistoryButton(): ReactNode {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        size="sm"
        variant="secondary"
        onClick={() => setOpen(true)}
        className="gap-1"
      >
        <History size={14} />
        Ver hist&oacute;rico
      </Button>
      <InvestmentHistoryModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
